import api from "./api";

export const getPostCategories = async () => {
    try {
        const res = await api.get("/api/post-categories", {
            params: { size: 9999 }
        });
        const responseData = res?.data;
        return Array.isArray(responseData) ? responseData : (responseData?.content || responseData?.items || responseData?.data || []);
    } catch (error) {
        console.error("Error fetching post categories:", error);
        return [];
    }
};



